module.exports = __webpack_public_path__ + "static/media/aroldo-explicando-direita.1f847af9.svg";